module.exports = __webpack_public_path__ + "img/allaria.a7e4ac78.png";